var _polygon, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElementLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 20.2",
    style: {
      enableBackground: "new 0 0 100 20.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "dot1",
    points: "84,10.3 84,10.3 84,10.3 84,10.3 "
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "10;0;0;0;0"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "cx",
    begin: "0s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "84;84;84;84;84"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dot2",
    cx: 16,
    cy: 10.3,
    r: 9.3
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "r",
    begin: "-0.8s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;10;10;10;0"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "cx",
    begin: "-0.8s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "16;16;50;84;84"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "dot1",
    cx: 84,
    cy: 10.3,
    r: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "r",
    begin: "-0.4s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;10;10;10;0"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "cx",
    begin: "-0.4s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "16;16;50;84;84"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "dot3",
    cx: 81.6,
    cy: 10.3,
    r: 10
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;10;10;10;0"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "cx",
    begin: "0s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "16;16;50;84;84"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "dot1",
    cx: 47.6,
    cy: 10.3,
    r: 10
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;0;10;10;10"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "cx",
    begin: "0s",
    calcMode: "spline",
    dur: "1.6s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "16;16;16;50;84"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementLoader);
export default __webpack_public_path__ + "static/media/elementLoader.a0f06ec511d6c7e18150884468557abe.svg";
export { ForwardRef as ReactComponent };